module.exports = __webpack_public_path__ + "img/爱奇艺_01.e4bd1a0a.jpg";